"use client";

import { useEffect } from "react";

export function ErrorMonitor() {
	useEffect(() => {
		// 全局错误监听器
		const handleError = (event: ErrorEvent) => {
			const errorInfo = {
				message: event.message,
				filename: event.filename,
				lineno: event.lineno,
				colno: event.colno,
				error: event.error,
				stack: event.error?.stack,
				timestamp: new Date().toISOString(),
				userAgent: navigator.userAgent,
			};

			console.group("🚨 JavaScript Error Detected");
			console.error("Error Message:", errorInfo.message);
			console.error("File:", errorInfo.filename);
			console.error(
				"Line:Column:",
				`${errorInfo.lineno}:${errorInfo.colno}`,
			);
			console.error("Stack Trace:", errorInfo.stack);
			console.error("User Agent:", errorInfo.userAgent);
			console.error("Full Error Object:", errorInfo.error);
			console.groupEnd();

			// 可以在这里发送错误到你的错误监控服务
			// sendErrorToService(errorInfo);
		};

		// Promise 拒绝监听器
		const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
			const errorInfo = {
				reason: event.reason,
				promise: event.promise,
				timestamp: new Date().toISOString(),
				userAgent: navigator.userAgent,
			};

			console.group("🚨 Unhandled Promise Rejection");
			console.error("Reason:", errorInfo.reason);
			console.error("Promise:", errorInfo.promise);
			console.error("User Agent:", errorInfo.userAgent);
			console.groupEnd();

			// 可以在这里发送错误到你的错误监控服务
			// sendErrorToService(errorInfo);
		};

		// 添加事件监听器
		window.addEventListener("error", handleError);
		window.addEventListener("unhandledrejection", handleUnhandledRejection);

		// 清理函数
		return () => {
			window.removeEventListener("error", handleError);
			window.removeEventListener(
				"unhandledrejection",
				handleUnhandledRejection,
			);
		};
	}, []);

	return null;
}
